import { z } from 'zod';
import { SMTP_ENCRYPTIONS, emailSwitchMapSchema } from './email';
export const INSTALL_LINK_PATH = '/realtime-link';
export const INSTALL_LINK_NAMESPACE = '/install-link';
export const INSTALL_LINK_PING_INTERVAL_MS = 55_000;
export const INSTALL_LINK_PING_TIMEOUT_MS = 30_000;
export const INSTALL_LINK_RECONNECT_BASE_MS = 2_000;
export const INSTALL_LINK_RECONNECT_MAX_MS = 5 * 60_000;
export const INSTALL_LINK_FORWARD_TIMEOUT_MS = 30_000;
export const INSTALL_LINK_LOOPBACK_TIMEOUT_MS = 25_000;
export const INSTALL_LINK_MAX_REQUEST_BYTES = 1024 * 1024;
export const INSTALL_LINK_MAX_RESPONSE_BYTES = 4 * 1024 * 1024;
export const INSTALL_LINK_MAX_FRAME_BYTES = 8 * 1024 * 1024;
export const INSTALL_LINK_PATH_MAX = 400;
export const INSTALL_LINK_QUERY_MAX = 2_000;
export const INSTALL_LINK_LIVE_TOKEN_HEADER = 'x-live-token';
export const INSTALL_LINK_REFUSALS = ['unauthorized', 'revoked', 'not_activated', 'not_local', 'throttled', 'replaced', 'secret_changed'];
export const installLinkForwardRequestSchema = z.object({
    sessionId: z.string().uuid(),
    method: z.enum(['GET', 'HEAD', 'POST']),
    path: z.string().min(1).max(INSTALL_LINK_PATH_MAX),
    query: z.string().max(INSTALL_LINK_QUERY_MAX),
    headers: z.record(z.string().max(2_000)),
    body: z.unknown().optional(),
});
export const installLinkForwardResponseSchema = z.object({
    status: z.number().int().min(100).max(599),
    headers: z.record(z.string().max(2_000)),
    body: z.unknown().optional(),
});
export const WATCH_RELAY_EVENTS = ['peer', 'batch', 'control-request', 'control', 'input', 'end', 'ended'];
export const installLinkWatchOpenSchema = z.object({
    sessionId: z.string().uuid(),
    userId: z.string().min(1).max(80),
    userName: z.string().min(1).max(200),
    ownerId: z.string().min(1).max(80),
    ownerName: z.string().min(1).max(120),
    reason: z.string().min(1).max(400),
    startedAt: z.string().datetime(),
    endsAt: z.string().datetime(),
});
export const installLinkWatchMessageSchema = z.object({
    sessionId: z.string().uuid(),
    event: z.enum(WATCH_RELAY_EVENTS),
    payload: z.unknown().optional(),
});
export const OWNER_EMAIL_COPY_VERSION_LENGTH = 32;
export const ownerEmailCopySchema = z.object({
    smtp: z
        .object({
        host: z.string().min(1).max(253),
        port: z.number().int().min(1).max(65535),
        user: z.string().max(254).nullable(),
        password: z.string().max(500).nullable(),
        encryption: z.enum(SMTP_ENCRYPTIONS),
        fromAddress: z.string().min(3).max(254),
    })
        .nullable(),
    platform: z.object({ perDay: z.number().int().min(0), perMonth: z.number().int().min(0), switches: emailSwitchMapSchema }),
    tenant: z.object({
        dailyLimit: z.number().int().min(0).nullable(),
        monthlyLimit: z.number().int().min(0).nullable(),
        extraMonth: z.string().max(7).nullable(),
        extraCount: z.number().int().min(0),
        ownerSmtpAllowed: z.boolean(),
        switches: emailSwitchMapSchema,
    }),
});
export const ownerEmailSyncPayloadSchema = z.object({
    version: z.string().regex(/^[0-9a-f]{32}$/),
    sealed: z.string().min(10).max(6_000),
});
//# sourceMappingURL=install-link.js.map